import * as THREE from 'three';
import { CELL } from '../core/config';
import type { Cluster, PhysicsCity } from '../physics/world';
import type { City } from '../world/city';
import { terrainHeight, WATER_LEVEL } from '../world/terrain';

/** First contact of the actual occupied airframe with the rendered water
 * surface. The terrain underneath determines wet coverage; banks, bridges and
 * the finite river ends keep their ordinary physical collision. */
export function aircraftWaterContact(
  physics: PhysicsCity,
  city: City,
  cluster: Cluster,
  move: THREE.Vector3,
): { time: number; point: THREE.Vector3 } | undefined {
  if (!city.terrain || move.y >= 0 || cluster.body.translation().y > 45) return;
  let best: { time: number; point: THREE.Vector3 } | undefined;
  for (const box of cluster.collisionBoxes)
    for (const x of [box.x, box.x + box.w])
      for (const y of [box.y, box.y + box.h])
        for (const z of [box.z, box.z + box.d]) {
          const from = physics.toWorld(cluster, { x: x * CELL, y: y * CELL, z: z * CELL });
          if (from.y + move.y > WATER_LEVEL) continue;
          const time = Math.max(0, (WATER_LEVEL - from.y) / move.y);
          if (time > 1 || time >= (best?.time ?? Infinity)) continue;
          const point = from.addScaledVector(move, time);
          if ((terrainHeight(city.terrain, point.x, point.z) ?? Infinity) >= WATER_LEVEL - 0.02) continue;
          point.y = WATER_LEVEL;
          best = { time, point };
        }
  return best;
}
